module.exports = __webpack_public_path__ + "img/kisi_pic.c848cf17.jpg";